import { CLEAR_ERROR_NOTIFICATION_CONTENT } from "../../../../enums/MyDivision/Delegation/AuthorityDelegation.types";

export const clearErrorNotificationContentAction = () => {
    return {
        type: CLEAR_ERROR_NOTIFICATION_CONTENT,
    };
};